import { intervalToDuration,formatDuration } from "date-fns";

export const secondsToHuman = (value: number) =>{
    const i = intervalToDuration({start: 0, end: value * 1000});
    return formatDuration(i);
}